import { render } from "./WalletInstructionVideos.vue?vue&type=template&id=44fa2360"
import script from "./WalletInstructionVideos.vue?vue&type=script&lang=js"
export * from "./WalletInstructionVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__